<template>
  <span>
    <i v-if="type == 'Web or App'" class="material-icons mr-2">computer</i>
    <i v-if="type == 'Factory'" class="material-icons mr-2">corporate_fare</i>
    <i v-if="type == 'Security'" class="material-icons mr-2">lock</i>
    <i v-if="type == 'Office'" class="material-icons mr-2">home_work</i>
    <i v-if="type == 'Data'" class="material-icons mr-2">insert_chart</i>
    <i v-if="type == 'Facilities'" class="material-icons mr-2"
      >heath_and_safety</i
    >
    <span v-if="showText">{{ type }}</span>
  </span>
</template>

<script>
export default {
  props: ['type', 'showText'],
}
</script>
